import React, { useState } from 'react';
import ProjectSettingsSwitches from './project-components/ProjectSettingsSwitches';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    FormControlLabel,
    Switch,

    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '660px',
    width: '96%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};



const rows = [
    {
        email: 'nikita@acadecraft.net',
        created: true,
        downloaded: true,
        tracked: false
    },
    {
        email: 'ui@acadecraft.net',
        created: true,
        downloaded: true,
        tracked: false
    },
    {
        email: 'alex@acadecraft.net',
        created: true,
        downloaded: false,
        tracked: false
    }
];

const StatusIcon = ({ status }) => (
    status ? (
        <img src="./assets/images/app-activity/popup-icon/check-green-icon.svg" className='img-fluid' alt='check-green-icon' />
    ) : (
        <img src="./assets/images/app-activity/popup-icon/cancel-red-icon.svg" className='img-fluid' alt='cancel-red-icon' />
    )
);
const TeamOnboarding = ({ open, onClose }) => {
    
    const [disableActivity, setDisableActivity] = useState(false);
    

    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Team Onboarding</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 16px' }}>
                            <Box>
                                <Typography fontWeight={'400'} sx={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#64748B', fontFamily: 'Manrope', margin: '0 auto 4px' }}>Monitor onboarding status of invited members and send reminders to complete the process.</Typography>
                                <Typography display="flex" alignItems="center" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', margin: '0 auto 2px', fontFamily: 'Manrope' }}>Show Onboarded Members</Typography>
                            </Box>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={disableActivity}
                                        onChange={() => setDisableActivity(!disableActivity)}
                                        color="primary"
                                        sx={{
                                            width: 40,
                                            height: 25,
                                            padding: 0,
                                            '& .MuiSwitch-switchBase': {
                                                padding: 0.5,
                                                '&.Mui-checked': {
                                                    transform: 'translateX(16px)',
                                                    color: '#fff',
                                                    '& + .MuiSwitch-track': {
                                                        backgroundColor: '#E0EEFE',
                                                        opacity: 1,
                                                        border: '1px solid #0076FE1F',

                                                    },
                                                    '& .MuiSwitch-thumb': {
                                                        backgroundColor: '#0076FE',
                                                    }
                                                },
                                            },
                                            '& .MuiSwitch-thumb': {
                                                width: 13,
                                                height: 13,
                                                boxShadow: ' 0 1px 1px #00000040',
                                                margin: '2px auto 0',
                                            },
                                            '& .MuiSwitch-track': {
                                                borderRadius: '20px',
                                                backgroundColor: '#E5E8EB',
                                                opacity: 1,
                                                border: '1px solid #D0D5DD',
                                            },
                                        }}
                                    />
                                }
                            />
                        </Box>
                    </Box>


                    <TableContainer component={Paper} elevation={0} sx={{ margin: '32px auto' }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#e0e0e0' }}>
                                <TableRow>
                                    <TableCell sx={{ fontSize: '10px', fontWeight: '500', color: '#878787', fontFamily: 'Manrope', p: '12px', border: 'none' }}>Member Email</TableCell>
                                    <TableCell sx={{ fontSize: '10px', fontWeight: '500', color: '#878787', fontFamily: 'Manrope', p: '12px', border: 'none' }}>Created Account</TableCell>
                                    <TableCell sx={{ fontSize: '10px', fontWeight: '500', color: '#878787', fontFamily: 'Manrope', p: '12px', border: 'none' }}>Downloaded App</TableCell>
                                    <TableCell sx={{ fontSize: '10px', fontWeight: '500', color: '#878787', fontFamily: 'Manrope', p: '12px', border: 'none' }}>Tracked Time</TableCell>
                                    <TableCell sx={{ fontSize: '10px', fontWeight: '500', color: '#878787', fontFamily: 'Manrope', p: '12px', border: 'none' }}>Send Reminder</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell sx={{ p: '12px 12px', border: 'none', fontSize: '12px', fontWeight: '500', color: '#1A1F36', fontFamily: 'Manrope' }}>{row.email}</TableCell>
                                        <TableCell sx={{ p: '12px 12px', border: 'none' }} align='center'><StatusIcon status={row.created} /></TableCell>
                                        <TableCell sx={{ p: '12px 12px', border: 'none' }} align='center'><StatusIcon status={row.downloaded} /></TableCell>
                                        <TableCell sx={{ p: '12px 12px', border: 'none' }} align='center'><StatusIcon status={row.tracked} /></TableCell>
                                        <TableCell sx={{ p: '12px 12px', border: 'none' }} align='center'><img src='./assets/images/app-activity/popup-icon/send-icon.svg' className='img-fluid' alt='send-icon' /></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box display="flex" alignItems="center" sx={{ p: '12px 16px', border: '1px solid #0076FE', backgroundColor: '#0076FE0A', borderRadius: '8px', gap: '12px', }}>
                        <img src='./assets/images/app-activity/popup-icon/team-members.svg' className='img-fluid' alt='team members' style={{ height: '20px', width: '20px' }} />
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Manrope', color: '#1A1F36' }}>Team members can track time in various ways. Adjust timer app settings to record screenshots and activity (desktop app only).</Typography>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'end', gap: 2, borderRadius: '0 0 12px 12px', borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Close
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default TeamOnboarding;
